import firstCharToUpper from "./stringFormat";


export default function errorObject(validationErrorMessages) {
    const errorObject = {}
    validationErrorMessages.forEach(message => {
        errorObject[message.loc[message.loc.length - 1]] = firstCharToUpper(message.msg);
    })
    return errorObject;
}